import React, { Component } from "react";

// Algolia
import {
    GoogleMapsLoader,
    GeoSearch,
    Control,
    Marker,
    CustomMarker
} from "react-instantsearch-dom-maps";

class Map extends Component {
    render() {
        return (
            <GoogleMapsLoader apiKey="AIzaSyBF309Ebqm5wu2mCEMq1ceOI7ACSYmJqek">
                {google => (
                    <GeoSearch
                        enableRefineOnMapMove={false}
                        google={google}
                    >

                        {({ hits }) => {
                            return (
                                <div>
                                    <Control />
                                    {hits.map(hit => (
                                        !!hit._geoloc.lat && !!hit._geoloc.lng &&
                                        <CustomMarker
                                            key={hit.objectID}
                                            hit={hit}
                                        >
                                            <Marker
                                                key={hit.objectID}
                                                hit={hit}
                                            />
                                            <a
                                                href={`/${hit.slug}`}
                                                target="_blank"
                                                className="il-map-thumb"
                                            >
                                                <div className="popover il-map-popover bs-popover-bottom">
                                                    <div className="arrow"></div>
                                                    <div className="popover-body truncate">
                                                        {hit.title}
                                                    </div>
                                                </div>
                                            </a>
                                        </CustomMarker>
                                    ))}
                                </div>
                            );
                        }}
                    </GeoSearch>
                )}
            </GoogleMapsLoader>
        );
    }
}

export default Map;
